<template>
    <z-page>
        <!-- 搜索栏 -->
        <div class="page-search">
            <div class="search-item">
                <div>搜索：</div>
                    <div class="long">
                        <el-input 
                            size="mini"
                            class="long"
                            v-model="searching.text" 
                            placeholder="关键字搜索" 
                            suffix-icon="el-icon-search">
                            <el-select style="width:100px;" v-model="searching.text_type" slot="prepend" placeholder="请选择">
                                <el-option label="产品名称" :value="1"></el-option>
                                <el-option label="经销商" :value="2"></el-option>
                            </el-select>
                        </el-input>
                    </div>
            </div>
            <div @click="searchData" class="search-btn z-btn normal">搜索</div>
            <div @click="claersearch" style="margin-left:10px" class="search-btn">清除搜索</div>
            
        </div>
        <!-- 列表 -->
        <div class="page-list">
            <div class="list-head">
                <div>产品名称</div>
                <div>经销商</div>
                <div>分成比例</div>
                <div>分成比例调整</div>
            </div>
            <div v-loading='loading' class="list-main">
                <div style="text-align:center" v-if="data.list.length<=0" class="list-item"  >
                    暂无数据
                </div>
                <div class="list-item" v-for="(item,index) in data.list" :key="index" >
                    <div>{{ item.product_name }}</div>
                    <div >{{ item.distributor_name }}</div>
                    <div >{{ item.rate }}%</div>
                    <div>
                        <span class="font-btn unclick" v-if="item.kqd_distributor_id==0">修改</span>
                        <span v-else class="font-btn normal" @click="editopen(item)">修改</span>
                    </div>
                </div>
                
            </div>
            <!-- <z-pagination
                @sizeChange="getData()"
                @pageChange="handleCurrentChange"
                :current-page.sync="now_page"
                :page-size="10"
                :total='total'
                >
        </z-pagination> -->
        </div>
        <!-- 修改界面 -->
        <z-windowPop
            v-model="editshow"
            width='454px'
            :black='true'
            :btnshow='true'
            @confirm="$func.shake(editreta)"
            top='50%'
            title="分成比例调整"
            >
            <div class="page-search">
            <div class="search-item">
                <div>分成比例:</div>
                    <div style="padding-left:20px;">
                        <el-input 
                            size="mini"
                            v-model="now_list.rate" 
                            suffix-icon="el-icon-search">
                        </el-input>
                    </div>
            </div>
        </div>
        </z-windowPop>
    </z-page>
</template>
<script>
export default {
    data(){
        return{
            editshow:false,     //修改界面出现
            loading:false,      //加载中
            now_list:{},        //修改数据容器
            searching:{         //搜索框容器
                text_type:1,
                text:'',
            },
            searchdata:{        //真正要搜索时的搜索值

            },
            data:{              //数据列表容器
                list:[],
            }
        }
    },
    created(){
        this.getData()
    },
    methods:{
        
        // 打开修改弹窗
        editopen(item){
            this.now_list=JSON.parse(JSON.stringify(item))
            this.editshow=true
            },
        // 修改方法
        editreta(){
            let url = `api/supplier/distribute/change`
                this.$http.post(url,'',{
                    params:{
                    id:this.now_list.id,
                    rate:this.now_list.rate,
                    }})
                    .then(res=>{
                        if(res.code=='200'){
                            this.successTip('修改成功!')
                            this.getData();
                        }else{
                            this.errorTip('修改失败!')
                        }
                    })
                    this.editshow=false
        },
        // 清除搜索条件并搜索
        claersearch(){
            this.searchdata={}
            this.searching={
                text_type:1,
                text:'',
            }
            this.getData(1);
        },
        //获取搜索条件并搜索
        searchData(){
            this.searchdata=this.searching;
            if(this.searching.text_type==2){
                this.searchdata.manage=this.searching.text;
            }else{
                this.searchdata.product=this.searching.text;
            }
            this.getData(1);
        },
        //获取数据
        getData(search){          
                this.loading=true
                let url = `/api/supplier/get/distribute/list`
                this.$http.get(url,{params:{
                    page:search||this.now_page,
                    product_name:this.searchdata.product,
                    distribute_name:this.searchdata.manage
                    }})
                .then(res=>{
                    if(res.code == 200){
                        this.data = res.res_data;
                        this.total=res.res_data.total
                        
                    }
                    this.loading=false;
                })
                .catch(err=>{
                    this.loading=false;
                })
            },
    }
}
</script>
<style lang="less" scoped>
.list-head,.list-item{
        >div{
            width: 25%;
            &:nth-child(4),&:nth-child(3),&:nth-child(2){
                text-align: center;
            }
        }
    }

</style>
